const isValid = value => null != value;

export default isValid;
//# sourceMappingURL=isValid.js.map